import LoadingButton from '@mui/lab/LoadingButton';
import PropTypes from 'prop-types';
import { atomButton_style } from './style';

export function Button(props) {
  const {
    children,
    variant = 'contained',
    disabled,
    startIcon = '',
    endIcon = '',
    component = '',
    loading,
    size = 'medium',
    fullWidth = true,
    buttonStyle = {},
    href,
    onClick = () => {},
    className = '',
    id,
    ...rest
  } = props;
  return (
    <LoadingButton
      id={id}
      variant={variant}
      startIcon={startIcon}
      endIcon={endIcon}
      disabled={disabled}
      size={size}
      component={component}
      href={href}
      sx={{ ...atomButton_style.buttonSx, ...buttonStyle }}
      fullWidth={fullWidth}
      onClick={onClick}
      className={`${className}`}
      loading={loading}
      {...rest}
    >
      {children}
    </LoadingButton>
  );
}

Button.propTypes = {
  variant: PropTypes.oneOf(['contained', 'outlined', 'text']),
  children: PropTypes.any,
  disabled: PropTypes.any,
  loading: PropTypes.any,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
  fullwidth: PropTypes.bool,
  id: PropTypes.any,
  onClick: PropTypes.func,
  classes: PropTypes.object,
  href: PropTypes.string,
  sx: PropTypes.object,
  component: PropTypes.string,
  fullWidth: PropTypes.bool,
  buttonStyle: PropTypes.object,
  className: PropTypes.string,
};
